<sd-4-5-1-drawer
  #drawer
  (sd-show)="update()"
  (sd-hide)="apply($event)">
  <div class="drawer-content">

    <ng-template #buttons>
      <div class="buttons">
        <sd-4-5-1-button (click)="showFonds($event)">
          {{ 'advancedFundList.showFunds' | transloco }}
        </sd-4-5-1-button>

        <sd-4-5-1-button (click)="resetAllFilters()">
          <div class="filter-reset-button">
            <sd-4-5-1-icon
              library="system"
              name="closing-round"></sd-4-5-1-icon>
            {{ 'advancedFundList.resetAllFilters' | transloco }}
          </div>
        </sd-4-5-1-button>
      </div>
    </ng-template>

    <ng-container *ngTemplateOutlet="buttons"></ng-container>

    <div
      class="filter-blocks"
      [wctApiCallInject]="filters">
      @for (filter of displayedFilters(); track filter.title) {
        <section
          wct-fonds-filter-block
          [data]="filter"
          [selection]="selections"
          [update$]="update$"
          (dirty)="dirty = true"></section>

        @if (!$last) {
          <sd-4-5-1-divider></sd-4-5-1-divider>
        }
      }
    </div>

    <ng-container *ngTemplateOutlet="buttons"></ng-container>

  </div>
</sd-4-5-1-drawer>
